import classNames from 'classnames';

import { Props, StatusBadgeVariantEnum } from './ReferralStatusBadge.types';

import styles from './ReferralStatusBadge.module.scss';

const VARIANT_STYLES: Record<StatusBadgeVariantEnum, string> = {
  [StatusBadgeVariantEnum.success]: styles.success,
  [StatusBadgeVariantEnum.neutral]: styles.neutral,
  [StatusBadgeVariantEnum.warning]: styles.warning,
  [StatusBadgeVariantEnum.danger]: styles.danger,
};

const ReferralStatusBadge = ({ label, variant, compact = false }: Props) => (
  <div className={classNames(styles.badge, VARIANT_STYLES[variant], { [styles.compact]: compact })}>
    {label}
  </div>
);

export default ReferralStatusBadge;
